import { useState, useEffect } from "react";
import axios from "axios";
import * as XLSX from "xlsx";
import { today } from "../../../util/formatDate";
import { postAxios } from "../../../util/postAxios";

export const useEditUser = () => {
  const getToken = localStorage.getItem("auth")
    ? localStorage.getItem("auth")
    : null;
  const getTim = localStorage.getItem("user");
  const jsonRole = JSON.parse(getTim);
  const jsonTim = JSON.parse(getTim);

  const [statusCode, setStatusCode] = useState();
  const [dataUser, setDataUser] = useState();
  const [popUp, setPopUp] = useState(false);
  const [popUpImport, setPopUpImport] = useState(false);
  const [peopleInfo, setPeopleInfo] = useState([]);
  const [peopleInfoAll, setPeopleInfoAll] = useState(false);

  const [file, setFile] = useState(null);
  const [isReload, setIsReload] = useState(false);

  const [isPopUpContract, setIsPopupContract] = useState(false);
  const [dataPickContract, setDataPickContract] = useState();

  const [dataPickHistoryContract, setDataPickHistoryContract] = useState();

  const [dateFrom, setDateFrom] = useState(today);
  const [dateUntil, setDateUntil] = useState(today);
  const [posisi, setPosisi] = useState("");
  const [umur, setUmur] = useState();

  const [isDisabled, setIsDisabled] = useState(false);

  const [isPopUpListContract, setIsPopUpListContract] = useState(false);

  const [kontrakList, setKontrakList] = useState([]);
  const [loadingKontrakList, setLoadingKontrakList] = useState(false);

  const [isCreated, setIsCreated] = useState(false);

  const [selectedYear, setSelectedYear] = useState("Semua");

  const availableYears = Array.from(
    new Set(
      kontrakList
        .map((k) => k.dateFrom && new Date(k.dateFrom).getFullYear())
        .filter(Boolean)
    )
  ).sort((a, b) => b - a);

  const filteredKontrakList =
    selectedYear === "Semua"
      ? kontrakList
      : kontrakList.filter(
          (k) =>
            k.dateFrom &&
            new Date(k.dateFrom).getFullYear() === Number(selectedYear)
        );

  const getTableData = async () => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_ENDPOINT}/userList`,
        { type: "editUser", tim: jsonTim.tim },
        {
          headers: {
            Authorization: `Bearer ${getToken}`,
          },
        }
      );
      if (response.data.code === 404) {
        setStatusCode(
          response.data.code !== undefined ? response.data.code : ""
        );
      } else {
        let result1 = [],
          result2 = [];

        for (let i = 0; i < response.data.length; i++) {
          if (response.data[i].probation === true) {
            result1.push(response.data[i]);
          } else {
            result2.push(response.data[i]);
          }
        }

        result2.sort(function (a, b) {
          if (a.deviceId === "deactivate" && b.deviceId !== "deactivate") {
            return -1;
          }

          if (a.deviceId !== "deactivate" && b.deviceId === "deactivate") {
            return 1;
          }

          return a.name.localeCompare(b.name);
        });

        let result = result1.concat(result2);

        setDataUser(result);
      }
    } catch (error) {
      return error;
    }
  };

  useEffect(() => {
    const getKontrakList = async () => {
      if (!dataPickHistoryContract?.id) return;
      setLoadingKontrakList(true);
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_ENDPOINT}/getKontrakUser`,
          { userId: dataPickHistoryContract.id },
          {
            headers: {
              Authorization: `Bearer ${getToken}`,
            },
          }
        );
        setKontrakList(response?.data.data || []);
        setSelectedYear("Semua");
      } catch (error) {
        setKontrakList([]);
      } finally {
        setLoadingKontrakList(false);
      }
    };

    if (isPopUpListContract && dataPickHistoryContract) {
      getKontrakList();
    }
  }, [isPopUpListContract, dataPickHistoryContract]);

  useEffect(() => {
    getTableData();
    setIsReload(false);
  }, [isReload]);

  const handleOpenNewContract = (user) => {
    setIsCreated(false);
    setDataPickContract(user);
    setPosisi(user?.position || "");
    setUmur("");
    setDateFrom(today);
    setDateUntil(today);
    setIsPopupContract(true);
  };

  const handlePickKontrak = (kontrak) => {
    setDataPickContract(dataPickHistoryContract);
    setDateFrom(kontrak.dateFrom || today);
    setDateUntil(kontrak.dateUntil || today);
    setPosisi(kontrak.posisi || dataPickHistoryContract?.position || "");
    setUmur(kontrak.umur || "");
    setIsCreated(kontrak.isCreated === true);
    setIsPopUpListContract(false);
    setIsPopupContract(true);
  };

  const [paramSearch, setParamSearch] = useState("nameId");
  const [valueSearch, setValueSearch] = useState("");
  const [editType, setEditType] = useState("Data Diri");

  const searchFeature = (params) => {
    if (paramSearch === "nameId" && valueSearch !== "") {
      let searchName = [];
      dataUser &&
        dataUser.forEach((value) => {
          if (value.name.toLowerCase().includes(params.toLowerCase())) {
            searchName.push(value);
          }
          if (value.id.includes(params)) {
            searchName.push(value);
          }
        });
      return searchName;
    } else {
      return dataUser;
    }
  };

  let dataTemp = searchFeature(valueSearch);

  const exportGaji = () => {
    const d = new Date();
    const year = d.getFullYear();

    let dataObject = [];

    dataUser &&
      dataUser.map((obj) => {
        if (obj.deviceId !== "deactivate") {
          dataObject.push({
            rekening: obj.bankAccountNumber,
            ktp: obj.id,
            nama: obj.name,
            bagian: obj.bagian,
            harian: Math.round(obj.basicSallary / 30),
            gaji: obj.basicSallary,
            uangMakan: obj.uangMakan,
            uangTransport: obj.uangTransport,
            bpjsK: obj.bpjsK,
            bpjsTK: obj.bpjsTK,
            shift: obj.kepalaShift,
          });
        } else {
          return {};
        }
      });

    const sortByNama = dataObject.sort(function (a, b) {
      if (a.nama < b.nama) {
        return -1;
      }
      if (a.nama > b.nama) {
        return 1;
      }
      return 0;
    });

    const workSheet = XLSX.utils.json_to_sheet(sortByNama);
    workSheet["!cols"] = [
      { wch: 15 },
      { wch: 18 },
      { wch: 35 },
      { wch: 17 },
      { wch: 13 },
      { wch: 13 },
      { wch: 13 },
      { wch: 14 },
      { wch: 10 },
      { wch: 10 },
    ];
    const workBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workBook, workSheet, "Data Gaji");
    XLSX.write(workBook, { bookType: "xlsx", type: "buffer" });
    XLSX.write(workBook, { bookType: "xlsx", type: "binary" });
    XLSX.writeFile(workBook, `Data Gaji Karyawan ${year}.xlsx`);
  };

  const exportDataDiri = () => {
    const d = new Date();
    const year = d.getFullYear();
    const dataObject = dataUser.map((obj) => {
      return {
        "No.Ktp": obj.id,
        Nama: obj.name,
        "No.NPWP": obj.npwpNumber,
        "No.Rekening": obj.bankAccountNumber,
        Email: obj.email,
        "No.Telepon": obj.phoneNumber,
        Alamat: obj.alamat,
        Bagian: obj.bagian,
        "K.A Shift": obj.kepalaShift,
        "Status Perkawinan": obj.statusPerkawinan,
        "Jumlah Anak": obj.jumlahAnak,
        "Tempat Tanggal Lahir": obj.tempatTanggalLahir,
        Posisi: obj.position,
        "Kontrak Awal": obj.kontrakAwal,
      };
    });

    const sortByNama = dataObject.sort(function (a, b) {
      if (a.Nama < b.Nama) {
        return -1;
      }
      if (a.Nama > b.Nama) {
        return 1;
      }
      return 0;
    });

    const workSheet = XLSX.utils.json_to_sheet(sortByNama);
    workSheet["!cols"] = [
      { wch: 17 },
      { wch: 27 },
      { wch: 20 },
      { wch: 15 },
      { wch: 30 },
      { wch: 15 },
      { wch: 35 },
      { wch: 20 },
      { wch: 11 },
      { wch: 17 },
      { wch: 12 },
      { wch: 35 },
      { wch: 15 },
      { wch: 17 },
    ];

    const workBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workBook, workSheet, "Data Gaji");
    XLSX.write(workBook, { bookType: "xlsx", type: "buffer" });
    XLSX.write(workBook, { bookType: "xlsx", type: "binary" });
    XLSX.writeFile(workBook, `Data Diri Karyawan ${year}.xlsx`);
  };

  const handleTambahHari = async () => {
    setPopUp(false);
    try {
      await axios.post(
        `${process.env.REACT_APP_ENDPOINT}/tambahHari`,
        {
          tim: jsonTim.tim,
          tambahAll: peopleInfoAll,
          tambahBeberapa: peopleInfo,
        },
        {
          headers: {
            Authorization: `Bearer ${getToken}`,
          },
        }
      );
    } catch (error) {
      return error;
    }
  };

  const handleConvert = () => {
    if (file) {
      const reader = new FileReader();
      reader.onload = async (e) => {
        const data = e.target.result;
        const workbook = XLSX.read(data, { type: "binary" });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        const json = XLSX.utils.sheet_to_json(worksheet);

        await axios.post(
          `${process.env.REACT_APP_ENDPOINT}/importDataUser`,
          { data: json },
          {
            headers: {
              Authorization: `Bearer ${getToken}`,
            },
          }
        );
      };
      reader.readAsBinaryString(file);
      setPopUpImport(true);
    }
    setIsReload(true);
    setValueSearch("");
  };

  const handleKirimKontrak = () => {
    if (posisi && umur && dataPickContract?.basicSallary > 0) {
      postAxios(
        `${process.env.REACT_APP_ENDPOINT}/addNewKontrakKaryawan`,
        {
          tim: jsonTim.tim,
          dateFrom: dateFrom,
          dateUntil: dateUntil,
          posisi: posisi,
          umur: umur,
          userId: dataPickContract.id,
          basicSallary: dataPickContract.basicSallary,
          name: dataPickContract.name,
        },
        getToken,
        "",
        ""
      );
      setTimeout(() => {
        setIsPopupContract(false);
        setPosisi("");
        setDateFrom(today);
        setDateUntil(today);
        setUmur();
        setDataPickContract();
        setDataPickHistoryContract();
        setIsDisabled(false);
      }, 500);
    } else {
      setIsDisabled(false);
    }
  };

  return {
    jsonRole,
    popUpImport,
    setPopUpImport,
    popUp,
    setPopUp,
    handleTambahHari,
    setFile,
    handleConvert,
    setValueSearch,
    setEditType,
    editType,
    exportGaji,
    exportDataDiri,
    peopleInfoAll,
    setPeopleInfoAll,
    dataTemp,
    peopleInfo,
    setPeopleInfo,
    isPopUpContract,
    setIsPopupContract,
    dataPickContract,
    setDataPickContract,

    dateFrom,
    setDateFrom,
    dateUntil,
    setDateUntil,
    posisi,
    setPosisi,
    umur,
    setUmur,
    handleKirimKontrak,
    isDisabled,
    setIsDisabled,
    isPopUpListContract,
    setIsPopUpListContract,
    kontrakList,
    loadingKontrakList,
    handlePickKontrak,

    selectedYear,
    setSelectedYear,
    availableYears,
    filteredKontrakList,

    isCreated,
    setIsCreated,
    dataPickHistoryContract,
    setDataPickHistoryContract,
    handleOpenNewContract,
    setIsReload,
  };
};
